import { delayOffset, intersectionWatcher } from "@/lib/animation";

const selectors = {
  textContent: ".video-hero__text-container > *",
};

export default node => {
  // Add the animation delay offset variables
  delayOffset(node, [selectors.textContent], 3);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
